// extracted by mini-css-extract-plugin
module.exports = {"root":"StopLicenseDialog_root__Fv7Bf","input":"StopLicenseDialog_input__3k9ED","inputInfo":"StopLicenseDialog_inputInfo__2tBXN"};